<script lang="ts">
    import { dictionary } from "@app/services/currentDictionary.service";

    import {
        SEARCH__emptyState,
        COMMON__Dictionary,
        COMMON__DictionaryTo,
        COMMON__notFound,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { fade } from "svelte/transition";
    import Keyboard from "./Keyboard.svelte";
    import { similarPhrases } from "./Search.store";
    import SimilarPhrasesItem from "./SimilarPhrasesItem.svelte";
    export let activeItem: number | undefined;
    export let reverse: boolean | undefined;

    let totalWords = 0;
    $: {
        totalWords = 0;
        if ($similarPhrases.straight && $similarPhrases.straight.words) {
            totalWords =
                $similarPhrases.straight.beforeCount +
                $similarPhrases.straight.afterCount;
        }
    }
    let totalWordsRev = 0;
    $: {
        totalWordsRev = 0;
        if ($similarPhrases.reverse && $similarPhrases.reverse.words) {
            totalWordsRev =
                $similarPhrases.reverse.beforeCount +
                $similarPhrases.reverse.afterCount;
        }
    }
</script>

{#if !reverse && totalWords > 0}
    <p class="uppercase text-gray-600 text-xs px-2 pt-2 truncate">
        {getMessage(COMMON__DictionaryTo, [
            $dictionary.l1.name,
            $dictionary.l2.name,
        ])}
    </p>
{/if}
{#if reverse && totalWordsRev > 0}
    <p class="uppercase text-gray-600 text-xs px-2 pt-4 truncate">
        {getMessage(COMMON__DictionaryTo, [
            $dictionary.l2.name,
            $dictionary.l1.name,
        ])}
    </p>
{/if}
<div class="w-full">
    {#if !reverse && (totalWords > 0 || totalWordsRev > 0)}
        <ul id="similar-phrases-list">
            {#if $similarPhrases.straight.words.phrases && $similarPhrases.straight.words.phrases.length > 0}
                {#each $similarPhrases.straight.words.phrases as similarPhrasesItem, index}
                    <SimilarPhrasesItem
                        {similarPhrasesItem}
                        dense={false}
                        active={activeItem === index}
                        {reverse}
                    />
                {/each}
            {/if}
        </ul>
    {/if}
    {#if reverse && totalWordsRev > 0}
        <ul id="similar-phrases-reverse-list">
            {#if $similarPhrases.reverse.words.phrases && $similarPhrases.reverse.words.phrases.length > 0}
                {#each $similarPhrases.reverse.words.phrases as similarPhrasesItem, index}
                    <SimilarPhrasesItem
                        {similarPhrasesItem}
                        dense={false}
                        active={activeItem === index}
                        {reverse}
                    />
                {/each}
            {/if}
        </ul>
    {/if}
</div>
